import type { Messages } from './en.js'

// Simplified Chinese (mainland vocabulary), distinct from the Traditional
// catalog in tw.ts — not a character conversion. Draft pending professional
// review in Tolgee.
export const cn: Messages = {
  'common.needHelp': '需要帮助吗？',
  'common.continue': '继续',
  'common.back': '返回',

  'shell.cookiePolicy': 'Cookie 政策',
  'shell.privacyPolicy': '隐私政策',
  'shell.cookiePreferences': 'Cookie 偏好设置',
  'shell.language': '语言',

  'login.title': '登录',
  'login.subtitle': '请使用您账户绑定的电子邮件。',
  'login.forgot': '忘记密码？',
  'login.createAccount': '创建账户',

  'forgot.title': '重置密码',
  'forgot.subtitle': '我们将向您的电子邮件发送 6 位验证码以设置新密码。',
  'forgot.newTitle': '设置新密码',
  'forgot.backToSignIn': '返回登录',

  'consent.message': '我们使用 Cookie 来运行本网站，并在取得您同意后用于衡量和改进。',
  'consent.acceptAll': '全部接受',
  'consent.essentialOnly': '仅必要',

  'common.email': '电子邮件',
  'common.password': '密码',
  'common.tryAgain': '重试',
  'err.tooManyAttempts': '尝试次数过多',
  'err.checkFailed': '验证失败',
  'err.otpDeliveryFailed': '我们无法发送验证码',
  'err.otpLocked': '验证码输入错误次数过多',
  'err.otpExpired': '此验证码已过期',
  'err.countryNotPermitted': '您所在的国家/地区暂不支持',
  'err.temporarilyUnavailable': '暂时不可用',
  'err.checkAnswers': '请检查您的答案',
  'err.somethingWrong': '出错了',

  'step.account': '账户',
  'step.identity': '身份验证',
  'step.compliance': '合规',
  'step.finish': '完成',

  'account.emailTitle': '开设您的账户',
  'account.emailSubtitle': '我们将向您的电子邮件发送 6 位验证码以确认地址。',
  'account.botFailedTitle': '机器人验证未加载',
  'account.botFailedBody': '您仍可继续 — 我们会在您提交时确认。',
  'account.send': '发送验证码',
  'account.sending': '发送中…',
  'account.haveAccount': '已有账户？',
  'account.login': '登录',
  'account.otpTitle': '输入您的验证码',
  'account.otpSentTo': '已发送至 {target}。',
  'account.otpTargetFallback': '您的电子邮件',
  'account.escalated': '我们已通过其他服务商发送了另一组验证码。',
  'account.startAgain': '重新开始',
  'account.checking': '检查中…',
  'account.verify': '验证',
  'account.resend': '重新发送验证码',
  'account.tryAnotherWay': '我没有收到 — 换一种方式',
  'account.differentEmail': '使用其他电子邮件',
  'account.profileTitle': '几项信息',
  'account.profileSubtitle': '这是账户设置的最后一步。',
  'account.emailReadonlyHint': '已通过您刚输入的验证码确认。',
  'account.country': '居住国家/地区',
  'account.countrySearch': '搜索国家/地区',
  'account.phone': '手机号',
  'account.consentBefore': '我同意按照以下政策收集和使用我的个人信息：',
  'account.consentAfter': '，并理解我可能会因申请事宜被联系。',
  'account.creating': '创建中…',
  'account.existsTitle': '您已有账户',
  'account.signInInstead': '改为登录',

  'partner.add': '有合作伙伴代码吗？',
  'partner.label': '合作伙伴代码 / Link ID',
  'partner.confirm': '应用代码',
  'partner.remove': '移除',
  'partner.close': '关闭合作伙伴代码',
  'partner.referredBy': '推荐人',
  'partner.partnerId': '合作伙伴编号',
  'partner.country': '国家/地区',
  'partner.unavailable': '无法验证该代码，请再试一次。',

  'identity.notReadyTitle': '请先完成您的账户',
  'identity.backToStep1': '返回步骤 1',
  'identity.title': '验证您的身份',
  'identity.subtitle': '法规要求我们在您交易前确认您的身份，大约需要两分钟。',
  'identity.startFailedTitle': '无法开始验证',
  'identity.step1': '请准备好您的护照、身份证或驾照。',
  'identity.step2': '您将拍摄证件照片，然后拍一张简短的自拍。',
  'identity.step3': '当浏览器询问时请允许使用摄像头 — 没有摄像头无法进行验证。',
  'identity.starting': '打开中…',
  'identity.start': '开始验证',
  'identity.partnerNote': '您将被带往我们的验证合作伙伴，并会立即返回此页。',
  'identity.inProgress': '您已开始。继续将从上次的进度接续。',
  'webview.title': '请在您的浏览器中打开此页面',
  'webview.cameraWarn': '摄像头通常无法在 {browser} 中使用，而身份验证需要摄像头。',
  'webview.namedBrowser': '{app} 的内置浏览器',
  'webview.thisBrowser': '此应用的内置浏览器',
  'webview.iosInstruction': '点击分享图标，然后选择 Open in Safari。',
  'webview.openInChrome': '在 Chrome 中打开',
  'webview.androidInstruction': '或使用菜单并选择 Open in browser。',
  'webview.otherInstruction': '将此页面的网址复制到您常用的浏览器。',

  'confirm.title': '确认您的信息',
  'confirm.subtitle': '我们已根据您的证件填写这些信息 — 请确认是否正确并修正有误之处。',
  'confirm.saveFailedTitle': '无法保存您的信息',
  'confirm.idOutstandingTitle': '我们仍需要您的证件',
  'confirm.idOutstandingBody':
    '您的身份验证尚未完成，请在下方填写您的信息。请继续完成申请 — 我们会通过电子邮件与您联系证件事宜。',
  'confirm.firstName': '名字',
  'confirm.lastName': '姓氏',
  'confirm.dob': '出生日期',
  'confirm.whereLive': '您居住在哪里？',
  'confirm.city': '城市',
  'confirm.state': '州 / 省',
  'confirm.saving': '保存中…',

  'compliance.stillCheckingTitle': '我们仍在核查您的证件',
  'compliance.backToVerification': '返回验证',
  'compliance.loading': '正在加载您的问卷…',
  'compliance.loadFailedTitle': '我们无法加载问卷',
  'compliance.stillStuck': '仍有问题？',
  'compliance.title': '最后几个问题',
  'compliance.subtitle': '法规要求我们在开户前询问这些问题。您的答案将与申请一并存档。',
  'compliance.submitting': '提交中…',
  'compliance.submit': '提交',
  'compliance.oneQuestionLeft': '还有 1 个问题需要回答。',
  'compliance.questionsLeft': '还有 {count} 个问题需要回答。',
  'compliance.saveAnswersFailed': '我们无法保存您的答案',

  'gate.stepToFinishTitle': '有一个步骤需要先完成',
  'gate.continueWhereLeft': '从上次的进度继续',

  'done.loadingDocs': '正在加载最后几份文件…',
  'done.loadFailedTitle': '我们无法加载您的文件',
  'done.tryAgainMoment': '请稍后重试。',
  'done.title': '最后一件事',
  'done.readyToSubmit': '您的申请已可提交。',
  'done.pleaseAccept': '在我们为您开户前，请阅读并接受这些文件。',
  'done.agreeAll': '我已阅读并同意全部 {count} 份文件',
  'done.hideDocs': '隐藏文件',
  'done.showDocs': '显示 {count} 份文件',
  'done.version': '版本 {version}',
  'done.finishing': '完成中…',
  'done.finishSignIn': '完成并登录',
  'done.oneLeft': '还有 1 份文件需要您接受。',
  'done.docsLeft': '还有 {count} 份文件需要您接受。',
  'done.straightIn': '我们会直接带您进入账户 — 无需再次登录。',
  'done.completeFailed': '我们无法完成您的申请',
  'done.acceptEvery': '请接受每一份文件',
  'done.getApps': '获取交易应用',
  'done.getAppsSubtitle': '开户后，您将通过 MT5 或 KCM Trade 应用进行交易。',
  'done.onComputer': '正在使用电脑吗？',
  'done.scanQr': '扫描二维码',
  'done.scanQrSuffix': '即可在手机上获取应用。',

  'kyc.approvedTitle': '身份已确认',
  'kyc.approvedBody': '谢谢 — 最难的部分已完成。',
  'kyc.reviewTitle': '我们正在审核您的文件',
  'kyc.reviewBody':
    '有专人正在审核 — 通常需要几个小时，完成后我们会立即通过电子邮件通知您。无需在此等待：请继续完成其余部分。',
  'kyc.questions': '有问题吗？',
  'kyc.declinedTitle': '我们无法验证您的身份',
  'kyc.contactPrefix': '请联系',
  'kyc.contactSuffix': '我们会接手处理。',
  'kyc.expiredTitle': '该会话已超时',
  'kyc.expiredBody': '验证会话开启的时间不长。重新开始只需几分钟。',
  'kyc.continueAnyway': '继续您的申请',
  'kyc.finishLaterBody':
    '您现在可以完成申请的其余部分。我们会另外通过电子邮件与您联系证件事宜，在此之前您的账户将保持待处理状态。',
  'decline.document_unreadable': '您的证件照片不够清晰而无法识别。改善光线并放在平面上通常可解决。',
  'decline.face_mismatch': '自拍与证件上的照片不匹配。',
  'decline.document_expired': '您使用的证件已过期。',
  'decline.other': '自动核查未能确认您的身份。',

  'verify.checkFailedTitle': '我们无法查询您的状态',
  'verify.checkFailedBody': '您的验证已提交。刷新此页面通常即可解决。',
  'verify.refresh': '刷新',
  'verify.stillProcessingTitle': '仍在处理中',
  'verify.stillProcessingBody':
    '这比平常花费更长时间。您的文件已提交且不会丢失 — 一旦有结果我们会立即通过电子邮件通知您。',
  'verify.back': '返回',
  'verify.checkingTitle': '正在核查您的文件',
  'verify.checkingBody': '通常只需几秒钟。请勿关闭此页面。',
  'verify.checkingAria': '正在核查您的验证',
  'handoff.receivedTitle': '已收到文件',
  'handoff.receivedBody': '谢谢 — 这是我们从您手机需要的全部资料。',
  'handoff.goBackTitle': '现在请回到您的电脑',
  'handoff.goBackBody':
    '您的申请仍在您开始的浏览器中打开。请在那里完成 — 验证完成后页面会自动继续。',
  'handoff.closeTab': '您可以关闭此标签页。',
  'handoff.somethingWrong': '有什么不对吗？',
}
